module.exports = __webpack_public_path__ + "static/media/newLogo.a26092fb.svg";